<template>
    <!-- IE 2026 08 20 / ODOO-336291 (mobile UX) (заказ Игоря): сайдбар тем же набором
         компонент, что рейл страниц — лёгкие плитки+пилюли без PrimeVue/ripple
         (прежний AppSubmenu заметно тормозил). Группы = узлы верхнего уровня. -->
    <div class="rail-menu">
        <!-- IE 2026 08 22 (заказ Игоря 11:02): заголовок списка -->
        <!-- IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2, по скрину сайдбара): справа вверху — команды Full screen и Log out
             (их иконки ушли из шапки в панели функций; здесь — под рукой при открытом списке столов) -->
        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
        <!-- IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку): первой слева —
             кнопка закрытия с тем же глифом ie-ico-panel-close, что у кнопки шапки при открытой панели; в overlay на desktop она стоит ровно над кнопкой шапки
             (стиль ниже, не-scoped блок); текст «Workspaces» — справа от неё, команды Full screen / Log out — справа, как были -->
        <div class="mobile-list-title rail-menu-head" v-uiHelp="'topbar.sidebar.head'">
            <span class="rail-menu-head-l">
                <button type="button" class="rail-menu-cmd rail-menu-close" v-wjTooltip="t('Close the list')" v-uiHelp="'topbar.sidebar.close'" @click="onClose($event)"><i class="pi ie-ico-panel-close"></i></button>
                <span class="rail-menu-head-text">{{ t('Workspaces') }}</span>
            </span>
            <span class="rail-menu-cmds">
                <button type="button" class="rail-menu-cmd" v-wjTooltip="t('Full screen')" v-uiHelp="'topbar.sidebar.fullscreen'" @click="onCmd($event, 'onFullscreen__Click')"><i class="pi pi-arrow-up-right-and-arrow-down-left-from-center"></i></button>
                <button type="button" class="rail-menu-cmd" v-wjTooltip="t('Log out')" v-uiHelp="'topbar.sidebar.logout'" @click="onCmd($event, 'onLogOut__Click')"><i class="pi pi-eject"></i></button>
            </span>
        </div>
        <template v-for="(cat, ci) in model" :key="ci">
            <!-- IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): подсказки (Alt / Show tooltips): категория — Category / Workspaces; стол — Workspace / Category / ID + кнопки новая вкладка / ссылка / запись стола -->
            <!-- IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): заголовок раздела — только когда в нём есть столы (wsItems без узлов-групп); пустая группа не рисуется вовсе -->
            <div class="rail-menu-cat" v-if="wsItems(cat).length" v-wjTooltipFn="catTip(cat)">{{ cat.label }}</div>
            <!-- IE 2026 08 27 / ODOO-5800 (заказ Игоря): пункт стола — настоящая ссылка (href того же маршрута, что и клик):
                 правая/средняя кнопка и Ctrl/Cmd+клик открывают стол в новой вкладке штатно, левый клик — внутри приложения -->
            <!-- IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): узел верхнего уровня без столов — строкой только если он сам стол (isWsRow: есть цель перехода);
                 узел-группа (WORKSPACES админа без столов вне меню) столом не рисуется никогда -->
            <a v-if="!wsItems(cat).length && isWsRow(cat)" class="rail-menu-row" :class="{ 'ws-current': isCurrentWs(cat) }" :href="hrefOf(cat)" v-wjTooltipFn="wsTip(cat, null)" @click="onClick($event, cat)">
                <span class="rm-icon"><i v-if="wsIco(cat)" :class="wsIco(cat)"></i><img v-else-if="cat.img" :src="cat.img"><i v-else :class="cat.pi || 'pi pi-folder'"></i><span class="page-badge rm-badge" v-if="wsBadge(cat)">{{ wsBadge(cat) }}</span></span><!-- IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили) -->
                <span class="rm-label">{{ cat.label }}</span>
            </a>
            <a v-for="(item, ii) in wsItems(cat)" :key="ci + '-' + ii" class="rail-menu-row" :class="{ 'ws-current': isCurrentWs(item) }" :href="hrefOf(item)" v-wjTooltipFn="wsTip(item, cat)" @click="onClick($event, item)">
                <span class="rm-icon"><i v-if="wsIco(item)" :class="wsIco(item)"></i><img v-else-if="item.img" :src="item.img"><i v-else :class="item.pi || 'pi pi-folder'"></i><span class="page-badge rm-badge" v-if="wsBadge(item)">{{ wsBadge(item) }}</span></span><!-- IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили) -->
                <span class="rm-label">{{ item.label }}</span>
            </a>
        </template>
        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
        <!-- IE 2026 09 23 / ODOO-341407: ревью i18n — подсказка логотипа: теги вне ключа -->
        <div class="rail-menu-logo" v-uiHelp="'topbar.sidebar.logo'"
            v-wjTooltip="t('Go to {site}', { site: '<b class=\'tooltip-header\'>webscm.ai</b>' }) + '<br>' + t('(opens in a new tab)') + '<br><br>' + store?.version_frontend + '<br>' + store?.version_backend">
            <a :href="store?.url" target="_blank" rel="noopener noreferrer"
                ><span class="logo1">Web</span><span class="logo">SCM</span></a>
        </div>
    </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { wsIconClass } from '@/utils/wsIcons'   // IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили)
import { workspaceIdOf } from '@/utils/tipActions'   // IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): id стола строки (workspace / query / href)
const _wsTips = new WeakMap(), _catTips = new WeakMap()   // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): функции подсказок по объекту пункта (модель меню пересобирается — WeakMap)

export default {
    props: { model: Array },
    emits: ['menuitem-click', 'close'],   // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки)
    setup() {
        const store = useMainStore()
        return { store }
    },
    methods: {
        // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): команды правого верхнего угла списка столов — как у пунктов меню пользователя;
        // после команды сайдбар-оверлей закрывается, как после выбора стола (menuitem-click)
        onCmd(event, command) {
            const action = command === 'onFullscreen__Click' ? { command, window: true } : { command }
            this.store.executeStoreMethod(this, action)
            this.$emit('menuitem-click', { originalEvent: event, item: { label: command } })
        },
        // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку): закрыть панель —
        // событие close, App.vue onSidebarClose (overlay / static / mobile)
        onClose(event) {
            this.$emit('close', { originalEvent: event })
        },
        // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): подсказки строк списка столов — стол: Workspace / Category / ID + кнопки (store.workspaceTip_fn); категория: Category / Workspaces
        wsTip(item, cat) { if (!item) return null; if (!_wsTips.has(item)) _wsTips.set(item, this.store.workspaceTip_fn(item, cat)); return _wsTips.get(item) },
        catTip(cat) { if (!cat) return null; if (!_catTips.has(cat)) _catTips.set(cat, this.store.categoryTip_fn(cat)); return _catTips.get(cat) },
        // IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): число ОТКРЫТЫХ страниц стола в углу плитки иконки — тем же бейджем, что число
        // открытых виджетов на плитке рейла страниц (Page.vue .page-badge). Страница открыта — store.workspaceOpenPages (хотя бы один открытый виджет
        // либо активная страница активного стола); нет открытых — бейджа нет; категории столов — без бейджа. Метод читает ALL_WIDGETS / activeWORKSPACE
        // в рендере — пересчёт реактивный (открытие / закрытие виджетов, смена страницы и стола). Выключатель fe.ux.workspaceOpenPagesBadge
        wsBadge(item) {
            if (!this.store?.workspaceOpenPages_on?.()) return ''
            const id = workspaceIdOf(item)
            const n = id ? this.store.workspaceOpenPages(id).length : 0
            return n ? this.store.formatCount(n) : ''
        },
        // IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили): картинка стола → глиф схемы иконок (Classic — картинка)
        wsIco(item) { return wsIconClass(item?.img, this.store?.iconScheme) },
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08 (скрин Игоря 10:50): подсветка
        // пункта ТЕКУЩЕЙ открытой рабочей области — IE 2026 11 02 / ODOO-349799 (workspace-wording)
        // IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): текущий стол — по id стола строки (workspaceIdOf: workspace / маршрут) = activeWORKSPACE.workspace; подпись —
        // только у строки без id. Подписи строк меню бэк локализует (get_menuTree → localize_attrs: «Стартова панель», «Закупівлі»), а record.title стола
        // приходит на языке базы («Launchpad», «Purchase») — в uk / ru текущий стол из меню не подсвечивался (скрин 2 Игоря 26.09: ни одна строка не текущая)
        isCurrentWs(item) {
            const ws = this.store?.activeWORKSPACE
            if (!ws || !item) return false
            const id = workspaceIdOf(item)
            const cur = ws.workspace || ws.record?.id
            if (id && cur) return id === String(cur)
            const t = ws.record?.title || ws.title
            return !!t && item.label === t
        },
        // IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): строка-стол — узел с целью перехода (маршрут to / ссылка url / id стола); узел-группа (Home / Data / WORKSPACES —
        // заголовок раздела, цели у него нет) столом не рисуется никогда: e43c3473 (20.08) рисовал узел верхнего уровня без пунктов строкой с иконкой-заглушкой
        // pi-folder, и пустая группа WORKSPACES админа (бэк отдаёт её без пунктов, фронт кладёт туда столы вне меню — «последние», ODOO-3749) выглядела столом
        isWsRow(node) { return !!node && !!(node.to || node.url || workspaceIdOf(node)) },
        // IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): столы раздела без узлов-групп; пусто — раздела нет (заголовок не рисуется)
        wsItems(cat) { return (cat && Array.isArray(cat.items)) ? cat.items.filter(it => this.isWsRow(it)) : [] },
        // IE 2026 08 27 / ODOO-5800 (заказ Игоря): href пункта = тот же маршрут, что и переход по клику
        // (hash-роутер → '#/<база>?workspace=…'); у пунктов без цели ссылки нет
        hrefOf(item) {
            if (item?.to) {
                try { return this.$router.resolve(item.to).href } catch (e) { return null }
            }
            return item?.url || null
        },
        onClick(event, item) {
            // IE 2026 08 27 / ODOO-5800: новая вкладка/окно (Ctrl/Cmd/Shift+клик, средняя кнопка) — отдать браузеру по href
            if (event && (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1)) return
            if (item?.to) {
                event?.preventDefault?.()
                this.$router.push(item.to)
            }
            this.$emit('menuitem-click', { originalEvent: event, item })
        },
    },
}
</script>

<style scoped>
.rail-menu {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 12px;
}
/* IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): команды в строке заголовка списка столов */
.rail-menu-head { display: flex; align-items: center; justify-content: space-between; gap: 6px; }
.rail-menu-cmds { display: inline-flex; gap: 2px; }
/* IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку): левая группа — кнопка закрытия + текст;
   глиф — как у кнопки шапки (.p-link-topbar-1 i: 1.5rem, scaleX(.85)), поля кнопки — как у .p-link-topbar (0 5px) */
.rail-menu-head-l { display: inline-flex; align-items: center; gap: 2px; min-width: 0; }
.rail-menu-cmd.rail-menu-close { padding: 0 5px; height: 32px; display: inline-flex; align-items: center; justify-content: center; }
.rail-menu-close i { font-size: 1.5rem; transform: scaleX(.85); }
/* IE 2026 10 29 / ODOO-5800 (слово Igor 29.10: шрифт «Робочі столи» как у названия стола в шапке): надпись заголовка панели — те же гарнитура (наследуемая от body, как у шапки),
   начертание 500 и ultra-condensed, что у .workspace-title в AppTopbar.vue (1.5rem → здесь 1.25rem, чтобы не раздувать строку с иконками); регистр и трекинг —
   обычные (мобильный .mobile-list-title даёт uppercase + .08em); цвет — заголовочный цвет гаммы на светлой панели (--cs-title: во всех гаммах тёмный), без гаммы — цвет текста темы */
.rail-menu-head-text {
    font-family: inherit;
    font-size: 1.25rem;
    font-weight: 500;
    font-stretch: ultra-condensed;
    letter-spacing: normal;
    text-transform: none;
    line-height: 1;
    color: var(--cs-title, var(--text-color));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    padding-left: 4px;
}
.rail-menu-cmd { background: none; border: none; padding: 2px 6px; cursor: pointer; color: var(--text-color-secondary, #6c757d); border-radius: 6px; font-size: 1rem; line-height: 1; }
@media (hover: hover) {
.rail-menu-cmd:hover { color: var(--text-color, #495057); background: var(--surface-hover, #e9ecef); }
}
.rail-menu-cat {
    text-transform: uppercase;
    font-weight: 600;
    font-size: .875rem;
    color: var(--surface-900);
    margin: 10px 0 2px;
}
.rail-menu-row {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    text-decoration: none;
    color: var(--text-color);
}
.rm-icon {
    position: relative; /* IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): бейдж .page-badge в углу плитки */
    width: 44px;
    height: 48px;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #6476ef66; /* 21.08 (скрин Игоря): плитки ярче */
    border-radius: 12px;
    font-size: 22px;
}
.rm-icon img {
    width: 28px;
    height: 28px;
    object-fit: contain;
}
/* IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): тот же бейдж, что число открытых виджетов на плитке рейла страниц
   (.page-badge — стили Page.vue не scoped: белый кружок в правом верхнем углу, цифра цветом акцента, гаммы красят через App.vue);
   размер — как у плитки 48px мобильного рейла (mobile-ui.css .page-badge: 9px / 12px), плитка стола такой же высоты */
.rm-icon .page-badge { font-size: 9px; height: 12px; min-width: 12px; }
/* IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили): глиф стола вместо картинки 28px — чуть крупнее прочих иконок */
.rm-icon i[class*="ie-ico-ws-"] { font-size: 26px; }
.rail-menu-row .rm-label {
    background-color: #d1d8f9;
    color: var(--text-color-secondary);
    border-radius: 12px;
    /* IE 2026 09 28 / ODOO-342342: вертикальный отступ 8px — прозрачной рамкой, а не padding (было padding: 8px 14px; размеры пилюли те же):
       overflow режет по краю padding-box, и третья строка длинного названия не выглядывает в нижний отступ под второй */
    padding: 0 14px; /* IE 2026 09 28 / ODOO-342342 */
    border-top: 8px solid transparent; /* IE 2026 09 28 / ODOO-342342: фон пилюли виден и под рамкой (background-clip: border-box) */
    border-bottom: 8px solid transparent; /* IE 2026 09 28 / ODOO-342342 */
    font-size: 1.5rem; /* 21.08 (скрин Игоря 11:24): как пилюли рейла страниц */
    /* IE 2026 09 28 / ODOO-342342 (ie-dm-app7, бой DM 28.09: «Панель управлен…», у текущего стола — и «Панель керува…»): длинное название
       стола — до ДВУХ строк вместо многоточия в первой. Короткое — одна строка: пилюля и шаг строки прежние (строку держит плитка 48px).
       Длиннее двух строк — многоточие во второй; полное название — строка Workspace подсказки стола (Alt / Show tooltips) */
    white-space: normal; /* IE 2026 09 28 / ODOO-342342: было nowrap */
    overflow-wrap: break-word; /* IE 2026 09 28 / ODOO-342342: слово длиннее пилюли — переносом, а не обрезкой */
    display: -webkit-box; /* IE 2026 09 28 / ODOO-342342: -webkit-line-clamp — только у -webkit-box */
    -webkit-box-orient: vertical; /* IE 2026 09 28 / ODOO-342342 */
    -webkit-line-clamp: 2; /* IE 2026 09 28 / ODOO-342342 */
    line-clamp: 2; /* IE 2026 09 28 / ODOO-342342 */
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background-color .15s, color .15s;
}
@media (hover: hover) { /* IE 2026 09 04 / ODOO-336291 (mobile UX): P-25 — ховер только курсору (на таче залипал после тапа) */
.rail-menu-row:hover .rm-label {
    background-color: #9da9f6;
    -webkit-text-stroke: 0.014em currentColor; /* IE 2026 09 29 / ODOO-… (заказ Игоря: ширина кнопки при наведении): вес 500 «на вид» — font-weight: 500 шире у шрифтов с этим начертанием */
}
}
/* IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08 (скрин Игоря 11:24): цвета гаммы —
   те же токены, что у рейла страниц (.page-hover-label) */
body[class*="cscheme-style"] .rail-menu-row .rm-label {
    background-color: color-mix(in srgb, var(--cs-accent) 16%, #fff) !important;
    color: var(--cs-title) !important;
}
body[class*="cscheme-style"] .rm-icon {
    background-color: color-mix(in srgb, var(--cs-accent) 32%, #fff) !important;
}
body[class*="cscheme-style"] .rail-menu-cat {
    color: var(--cs-title);
}
/* IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: текущая рабочая область выделена — IE 2026 11 02 / ODOO-349799 (workspace-wording) */
.rail-menu-row.ws-current .rm-label {
    background-color: #9da9f6;
    font-weight: 600;
}
.rail-menu-row.ws-current .rm-icon {
    background-color: #6476efa8;
    outline: 2px solid #6476ef;
    outline-offset: -2px;
}
body[class*="cscheme-style"] .rail-menu-row.ws-current .rm-label {
    background-color: var(--cs-accent) !important;
    color: #fff !important;
}
body[class*="cscheme-style"] .rail-menu-row.ws-current .rm-icon {
    background-color: color-mix(in srgb, var(--cs-accent) 55%, #fff) !important;
    outline-color: var(--cs-accent);
}
.rail-menu-logo {
    margin-top: 18px;
}
/* IE 2026 08 21 (скрин Игоря): логотип как в AppMenu — scoped-стили того файла
   сюда не достают, элемент рендерился простым текстом */
.rail-menu-logo .logo1 {
    font-size: 2.6rem; /* IE 2026 08 21: крупнее в ~1.5x (просьба Игоря) */
    font-weight: 900 !important;
    background: -webkit-linear-gradient(315deg, #42d392 25%, #4db9b5);
    font-stretch: ultra-condensed;
    border-radius: 3px;
    color: #ecf0f3;
    padding-inline: 0.4rem;
    margin: 0.1rem;
}
.rail-menu-logo .logo {
    font-size: 2.6rem; /* IE 2026 08 21: крупнее в ~1.5x (просьба Игоря) */
    font-weight: 900 !important;
    letter-spacing: -1.5px !important;
    background: -webkit-linear-gradient(315deg, #51acc3 25%, #647eff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>

<style>
/* IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку):
   desktop overlay — панель fixed с left 0 / top 0 и полями 1.5rem (_menu.scss, _responsive.scss); заголовок поднят на поле панели, кнопка закрытия сдвинута на левое поле:
   кнопка 34 × 32 px встаёт в (0, 0) окна — ровно над кнопкой шапки .topbar-ws-btn (её центр по замеру dev02: x 17, y 16; поля 0 5px, глиф 1.15em от 1.5rem).
   Static (панель под шапкой) и мобильный профиль (body.mobile-ui: свои поля и отступ под мобильной шапкой) — без сдвига, кнопка просто первой в заголовке */
@media (min-width: 992px) {
    body:not(.mobile-ui) .layout-overlay .rail-menu > .rail-menu-head { margin-top: -1.5rem; min-height: 32px; }
    body:not(.mobile-ui) .layout-overlay .rail-menu-head .rail-menu-close { margin-left: -1.5rem; }
}
</style>
